import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

import type { ClassValue } from "clsx";
import { getRequestEvent } from "solid-js/web";

/**
 * Combines multiple class names into a single string.
 *
 * @param inputs - The class names to combine.
 * @returns The combined class names.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getImageAsset(filepath: string) {
  return new URL(`@/assets/images/${filepath}`, import.meta.url).href;
}

type EnvKey = keyof NonNullable<
  ReturnType<typeof getRequestEvent>
>["nativeEvent"]["context"]["cloudflare"]["env"];

export function env(): Env | NodeJS.ProcessEnv;
export function env(key?: string): string | undefined;
export function env(
  key?: string,
): Env | NodeJS.ProcessEnv | string | undefined {
  const event = getRequestEvent();
  const env = event?.nativeEvent?.context?.cloudflare?.env ?? process.env;
  if (key && key in env) {
    return env[key as EnvKey];
  }

  return env ?? undefined;
}
